import { createSelector } from 'reselect';

const selectContacts = (state: any) => state.contacts;


export const selectContactsCurrentItem = createSelector([selectContacts], (contacts) => contacts.current);

export const selectContactsListItems = createSelector([selectContacts], (contacts) => contacts.list);

export const selectContactsItemById = (itemId: any) =>
    createSelector(selectContactsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectContactsQueryItems = createSelector([selectContacts], (contacts) => contacts.query);

export const selectContactsCreatedItem = createSelector([selectContacts], (contacts) => contacts.create);

export const selectContactsUpdatedItem = createSelector([selectContacts], (contacts) => contacts.update);

export const selectContactsReadItem = createSelector([selectContacts], (contacts) => contacts.read);

export const selectContactsDeletedItem = createSelector([selectContacts], (contacts) => contacts.delete);

export const selectContactsSearchedItems = createSelector([selectContacts], (contacts) => contacts.search);

export const selectContactsItemsCount = createSelector([selectContacts], (contacts) => contacts.count);

export const selectContactsItemsFilter = createSelector([selectContacts], (contacts) => contacts.filter);